import { ref } from "@vue/composition-api";
import { useRouter } from "@core/utils/utils";

const isSortDirDesc = ref(false);
const page = ref(1);
const perPage = ref(10);
const perPageOptions = [10, 25, 50, 100];
const searchQuery = ref();
const sortBy = ref("name");
const filters = ref({
    labels: [],
    filterOption: "or",
});

export default function useFilters() {
    const { route, router } = useRouter();

    const updateRouteQuery = (value) => {
        const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));

        if (value) {
            currentRouteQuery.s = value;
        } else {
            delete currentRouteQuery.s;
        }

        router.replace({ name: route.name, query: currentRouteQuery });
    };

    return {
        isSortDirDesc,
        page,
        perPage,
        perPageOptions,
        searchQuery,
        sortBy,
        filters,

        // Methods
        updateRouteQuery,
    };
}
